var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ '-logos': this.showLogos, '-slippage': this.showSlippage },attrs:{"id":"trades"}},[_c('ul',{ref:"tradesContainer"}),(!_vm.tradesCount)?_c('div',{staticClass:"trade -empty"},[_vm._v("Nothing to show, yet.")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }